/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UmsatzKumuliert
 */
export interface UmsatzKumuliert {
    /**
     * 
     * @type {number}
     * @memberof UmsatzKumuliert
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof UmsatzKumuliert
     */
    idPrognoseGruppe: number;
    /**
     * 
     * @type {number}
     * @memberof UmsatzKumuliert
     */
    idFirma: number;
    /**
     * 
     * @type {string}
     * @memberof UmsatzKumuliert
     */
    von: string;
    /**
     * 
     * @type {string}
     * @memberof UmsatzKumuliert
     */
    bis: string;
    /**
     * 
     * @type {number}
     * @memberof UmsatzKumuliert
     */
    umsatz: number;
}

/**
 * Check if a given object implements the UmsatzKumuliert interface.
 */
export function instanceOfUmsatzKumuliert(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "idPrognoseGruppe" in value;
    isInstance = isInstance && "idFirma" in value;
    isInstance = isInstance && "von" in value;
    isInstance = isInstance && "bis" in value;
    isInstance = isInstance && "umsatz" in value;

    return isInstance;
}

export function UmsatzKumuliertFromJSON(json: any): UmsatzKumuliert {
    return UmsatzKumuliertFromJSONTyped(json, false);
}

export function UmsatzKumuliertFromJSONTyped(json: any, ignoreDiscriminator: boolean): UmsatzKumuliert {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'idPrognoseGruppe': json['idPrognoseGruppe'],
        'idFirma': json['idFirma'],
        'von': json['von'],
        'bis': json['bis'],
        'umsatz': json['umsatz'],
    };
}

export function UmsatzKumuliertToJSON(value?: UmsatzKumuliert | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'idPrognoseGruppe': value.idPrognoseGruppe,
        'idFirma': value.idFirma,
        'von': value.von,
        'bis': value.bis,
        'umsatz': value.umsatz,
    };
}

